import React from "react";

function NotificationRow({ className = "", onOpen, onDismiss, children }) {
  return (
    <div className={`notif-row${className ? ` ${className}` : ""}`}>
      <button type="button" className="notif-row-main" onClick={onOpen}>
        {children}
      </button>
      <button
        type="button"
        className="notif-row-dismiss"
        aria-label="Dismiss notification"
        title="Dismiss"
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); onDismiss?.(); }}
      >
        ×
      </button>
    </div>
  );
}

export { NotificationRow };
